import React from "react";

import "./Spinner.scss";

const Spinner = () => {
  return (
    <div id="spinnerOverlay">
      <div id="spinnerContainer" />
    </div>
  );
};

export default Spinner;
